export const ALL_SEASONS = "All seasons";



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-sport-editor/constants.ts